import { Component } from '@angular/core';

/**
 * Component for auth layout
 * @export
 * @class TempAuthLayoutComponent
 */
@Component({
  selector: 'temp-auth-layout',
  templateUrl: './temp-auth-layout.component.html',
  styleUrls: ['./temp-auth-layout.component.scss'],
})
export class TempAuthLayoutComponent {}
